function getSymbolFromCurrencyCode(code) {
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: code.toUpperCase()
  });
  return formatter.formatToParts(0).find(p => p.type === 'currency').value // replace any alphanumeric characters
  .replace(/[A-Z]/gi, '');
}
function getFormattedCurrency(amount) {
  let code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  let trimZeroCents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: code
  });
  let formattedPrice = formatter.format(amount) // replace any alphanumeric characters
  .replace(/[A-Z]/gi, '');
  if (trimZeroCents && formattedPrice.endsWith('.00')) {
    formattedPrice = formattedPrice.slice(0, -3);
  }
  return formattedPrice;
}
function createPrice(amount, currencyCode) {
  const symbol = getSymbolFromCurrencyCode(currencyCode);
  const formattedPrice = getFormattedCurrency(amount, currencyCode);
  return {
    value: amount,
    currencySymbol: symbol,
    formatted: formattedPrice,
    formattedWithCurrencyCode: `${formattedPrice} (${currencyCode.toUpperCase()})`
  };
}
export { createPrice, getFormattedCurrency, getSymbolFromCurrencyCode };